import { render, staticRenderFns } from "./DMPush.vue?vue&type=template&id=3d52f854&scoped=true"
import script from "./DMPush.vue?vue&type=script&lang=js"
export * from "./DMPush.vue?vue&type=script&lang=js"
import style0 from "./DMPush.vue?vue&type=style&index=0&id=3d52f854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d52f854",
  null
  
)

export default component.exports